import React from "react";

import { BrandsUrlQueryParams } from "../../url";
import BrandsListPage from "./BrandsListPage";

export interface BrandsProps {
  params?: BrandsUrlQueryParams;
}

export const Brands: React.FC<BrandsProps> = ({ params }) => (
  <>
    <BrandsListPage params={params} />
  </>
);
export default Brands;
